import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MonedasComponent} from '../monedas.component'
//Services
import {CurrencyService} from 'src/app/core/services/parameters/currency.service';
//Alert
import {AlertNoticeService} from 'src/app/core/alert/alert.service';

@Component({
  selector: 'edit-modal',
  templateUrl: './edit-modal.html',
  styleUrls: ['./edit-modal.component.scss']
})
export class EditarMonedaModal implements OnInit {

  editCurrencyForm: FormGroup;
  loading = false;
  showAlert = false;
  currencyId;
  currencyData = {
    id: '',
    createdAt: ''
  };

  constructor(
    public dialogRef: MatDialogRef<MonedasComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,
    public alert: AlertNoticeService,
    private currencyService: CurrencyService
  ) {
  }

  ngOnInit(): void {
    this.editCurrencyForm = this.fb.group({
      country: [, Validators.required],
      currency: [, Validators.required],
      symbol: [, Validators.required],
      abbreviation: [, Validators.required],
      iva: [, Validators.required]
    })
    this.currencyId = this.data.id;
    this.currencyService.getCurrencyById(this.currencyId).subscribe(_res => {
      this.currencyData = _res;
      this.editCurrencyForm.patchValue({
        country: _res.country,
        currency: _res.name,
        symbol: _res.symbol,
        abbreviation: _res.divisa,
        iva: _res.tax
      })
    });
  }

  onNoClick(refresh): void {
    this.dialogRef.close(refresh);
  }

  get f() {
    return this.editCurrencyForm.controls;
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.editCurrencyForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  submit(form) {
    this.loading = true;
    this.showAlert = false;
    if (form.valid) {
      const data = {
        id: this.currencyId,
        name: form.value.currency,
        country: form.value.country,
        symbol: form.value.symbol,
        divisa: form.value.abbreviation,
        iva: form.value.iva
      }
        this.currencyService.updateCurrency(this.currencyId, data).subscribe(_res => {
            this.alert.setNotice('Moneda actualizada correctamente', 'success');
            this.showAlert = true;
            this.loading = false;
          setTimeout(() => this.onNoClick(true), 1000);
        }, _err => {
          this.alert.setNotice('No se pudo actualizar la moneda', 'danger');
          this.showAlert = true;
          this.loading = false;
        })
    } else {
      this.loading = false;
    }
  }

}
